import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { QrCode, Share2, X, Download } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { toast } from '../hooks/use-toast';

const WebsiteQRModal = ({ isOpen, onClose }) => {
  const websiteUrl = window.location.origin;

  const handleDownload = () => {
    const svg = document.getElementById('website-qr-code');
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL('image/png');
      
      const downloadLink = document.createElement('a');
      downloadLink.download = 'homesbyli-qr-code.png';
      downloadLink.href = pngFile;
      downloadLink.click();
      
      toast({
        title: 'QR Code downloaded!',
        description: 'The QR code has been saved to your device.',
      });
    };
    
    img.src = 'data:image/svg+xml;base64,' + btoa(svgData);
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: 'Homesbyli - Find Your Perfect Stay',
        text: 'Check out Homesbyli for amazing vacation rentals!',
        url: websiteUrl,
      }).catch(() => {});
    } else {
      navigator.clipboard.writeText(websiteUrl);
      toast({
        title: 'Link copied!',
        description: 'Website URL copied to clipboard',
      });
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[450px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <QrCode className="w-5 h-5" />
            Homesbyli Website QR Code
          </DialogTitle>
        </DialogHeader>

        <div className="py-6 space-y-6">
          {/* QR Code */}
          <div className="flex justify-center py-6 bg-gradient-to-br from-rose-50 to-white rounded-lg border-2 border-rose-200">
            <QRCodeSVG
              id="website-qr-code"
              value={websiteUrl}
              size={220}
              level="H"
              includeMargin={true}
              imageSettings={{
                src: 'https://em-content.zobj.net/source/twitter/376/house_1f3e0.png',
                height: 40,
                width: 40,
                excavate: true,
              }}
            />
          </div>

          <div className="text-center space-y-2">
            <p className="font-medium text-gray-900">Scan to visit Homesbyli</p>
            <p className="text-sm text-gray-600 break-all">{websiteUrl}</p>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-3">
            <Button
              onClick={handleDownload}
              className="flex-1 bg-rose-500 hover:bg-rose-600"
            >
              <Download className="w-4 h-4 mr-2" />
              Download
            </Button>
            <Button
              onClick={handleShare}
              variant="outline"
              className="flex-1"
            >
              <Share2 className="w-4 h-4 mr-2" />
              Share
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WebsiteQRModal;
